import SVGIcon from "../SVGIcon/SVGIcon";
import style from "./NoResults.module.css";

const NoResults = ({text, icon, iconSize}) => {
    return (
        <div className={style.Container}>
            <SVGIcon icon={icon} className={style.Icon}/>
            <p className={style.Message}>{text}</p>
        </div>
    )

}

export default NoResults;
    
